export const primaryColor: string = "#D3DE97";
export const secondaryColor: string = "#e49548";
export const tertiaryColor: string = "#ff5722";
export const accentColor: string = "#D3DE97";
export const white: string = "#fff";
export const black: string = "#000";
export const grey: string = "#696a6c";
export const lightGrey: string = "#fafafa";
